"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNavigatorAvailable = exports.isWindowAvailable = void 0;
/** Checks if the `window` global object is available. */
function isWindowAvailable() {
    return typeof window !== 'undefined';
}
exports.isWindowAvailable = isWindowAvailable;
/** Checks if the `navigator` global object is available. */
function isNavigatorAvailable() {
    return typeof navigator !== 'undefined';
}
exports.isNavigatorAvailable = isNavigatorAvailable;
